const agent_attorney_pocs_uischema = {
  view: "sub",
  title: {
    profileName: "[profile name]",
    legalBusinessName: "Microsoft",
    fein: "XX-XXXXXXX",
  },
  entity: "Individuals",
  linkBack: {
    name: "Back to Agent/Attorney (Firm) Profiles",
    link: "/dashboard/profiles/agent-attorney",
  },
  button: {
    name: "New Individuals",
    style: "outline",
  },
};

export default agent_attorney_pocs_uischema;
